export default {"src":"/_next/static/media/regular-simulations.db6f42bf.svg","height":234,"width":234,"blurWidth":0,"blurHeight":0};